"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _Button = _interopRequireDefault(require("../../button/Button"));

var _OptionsButton = _interopRequireDefault(require("../../button/OptionsButton"));

var _styling = require("../../../toolkit/styling");

var _providers = require("../../../toolkit/providers");

var _device = require("../../../toolkit/device");

var _localization = require("../../../toolkit/localization");

//
//  src/data/table/BatchActionSection.tsx
//  Project-Lego
//
//  Created by Sola Ogunsakin on 9/17/19.
//  Copyright © 2019-present ContextLogic Inc. All rights reserved.
//

/* Lego Components */

/* Lego Toolkit */
var BatchActionSection = function BatchActionSection(props) {
  var _DeviceStore$instance = _device.DeviceStore.instance(),
      isSmallScreen = _DeviceStore$instance.isSmallScreen;

  var styles = useStylesheet();
  var actions = props.actions,
      className = props.className,
      style = props.style,
      selectedRows = props.selectedRows;
  var numRowsSelected = selectedRows.length;

  var _useLocalization = (0, _localization.useLocalization)(),
      ni18n = _useLocalization.ni18n;

  if (actions.length == 0) {
    return null;
  }

  var numVisibleActions = isSmallScreen ? 1 : 4;
  var visibleActions = actions.slice(0, numVisibleActions);
  var hiddenActions = actions.slice(numVisibleActions);

  var isDisabled = function isDisabled(_ref) {
    var canApplyToRow = _ref.canApplyToRow;

    if (canApplyToRow == null) {
      return false;
    }

    if (numRowsSelected == 0) {
      return true;
    }

    return !selectedRows.every(function (row) {
      return canApplyToRow(row);
    });
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.root, className, style)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.buttons)
  }, visibleActions.map(function (action) {
    var name = action.name,
        onClick = action.perform,
        originalAction = action.originalAction,
        rest = (0, _objectWithoutProperties2["default"])(action, ["name", "perform", "originalAction"]);
    var disabled = isDisabled(originalAction);
    return /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({
      key: name,
      className: (0, _styling.css)(styles.button),
      onClick: onClick,
      padding: "7px 25px",
      disabled: disabled
    }, rest), name);
  }), hiddenActions.length > 0 && /*#__PURE__*/_react["default"].createElement(_OptionsButton["default"], {
    className: (0, _styling.css)(styles.button),
    options: hiddenActions.map(function (action) {
      var name = action.name,
          onClick = action.perform,
          originalAction = action.originalAction;
      var disabled = isDisabled(originalAction);
      return {
        title: name,
        onClick: onClick,
        disabled: disabled
      };
    })
  })), numRowsSelected > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.selectionCount)
  }, ni18n(numRowsSelected, "1 item selected", "{%1=number of selected items} items selected", numRowsSelected)));
};

var useStylesheet = function useStylesheet() {
  var _useTheming = (0, _providers.useTheming)(),
      _useTheming$theme = _useTheming.theme,
      surfaceLightest = _useTheming$theme.surfaceLightest,
      textDark = _useTheming$theme.textDark,
      fonts = _useTheming.fonts;

  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      root: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: surfaceLightest
      },
      selectionCount: {
        fontSize: 16,
        fontFamily: fonts.medium,
        lineHeight: 1.43,
        color: textDark
      },
      buttons: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
      },
      button: {
        animationName: [{
          from: {
            transform: "translateX(-6px)",
            opacity: 0
          },
          to: {
            transform: "translateX(0px)",
            opacity: 1
          }
        }],
        animationDuration: "100ms",
        marginRight: 15
      }
    });
  }, [surfaceLightest, textDark, fonts.medium]);
};

var _default = (0, _mobxReact.observer)(BatchActionSection);

exports["default"] = _default;